/** RJSF exposes shared step data in the registry; older field hosts pass it directly. */
export function intakeContext(props: {
  formContext?: { formData?: Record<string, unknown> };
  registry?: { formContext?: { formData?: Record<string, unknown> } };
}): Record<string, unknown> {
  return (
    props.registry?.formContext?.formData ?? props.formContext?.formData ?? {}
  );
}
